import { useTheme } from '@emotion/react';
import cn from 'classnames';

import { IConDefaultType } from '..';

export enum SendIconVariant {
  ORIGINAL = 'original',
  RENEWAL = 'renewal',
  BUBBLE_CHAT = 'bubble_chat',
  OUTLINED = 'outlined',
  FILLED = 'filled',
}

export interface ISendIconProps extends IConDefaultType {
  variant?: SendIconVariant;
}

function SendIcon({
  color,
  className,
  size = 28,
  rotate,
  flip,
  variant = SendIconVariant.ORIGINAL,
  style,
}: ISendIconProps) {
  const theme = useTheme();
  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
        ...style,
      }}
    >
      {variant === SendIconVariant.ORIGINAL && (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M6.2955 21.5C5.69977 21.5002 5.1108 21.3733 4.56771 21.1274C4.02461 20.8816 3.53981 20.5227 3.1455 20.0743C2.53391 19.4212 2.14439 18.5902 2.03299 17.7008C1.92158 16.8114 2.09401 15.9094 2.5255 15.1246L4.2255 11.972C4.26489 11.8978 4.2855 11.8151 4.2855 11.731C4.2855 11.647 4.26489 11.5642 4.2255 11.4901L2.5255 8.35758C2.09929 7.5768 1.92701 6.68172 2.03281 5.79772C2.13861 4.91373 2.51719 4.0851 3.1155 3.42792C3.70503 2.76382 4.48657 2.30131 5.35079 2.1051C6.21501 1.90888 7.11871 1.98875 7.93549 2.33355L18.7255 6.8315C19.6949 7.23363 20.5234 7.91605 21.1057 8.79203C21.6879 9.668 21.9976 10.698 21.9955 11.7511C21.999 12.8045 21.6898 13.8351 21.1074 14.7113C20.525 15.5876 19.6957 16.2697 18.7255 16.6707L7.9555 21.1486C7.43018 21.373 6.86632 21.4923 6.2955 21.5ZM6.2955 4.01024C5.97978 4.01496 5.66844 4.08519 5.38105 4.2165C5.09366 4.34781 4.83642 4.53738 4.6255 4.77328C4.30321 5.12239 4.09956 5.56515 4.04385 6.03785C3.98814 6.51055 4.08326 6.9888 4.3155 7.40378L6.01549 10.5564C6.21685 10.9221 6.32247 11.3332 6.32247 11.7511C6.32247 12.169 6.21685 12.5801 6.01549 12.9459L4.3155 16.1286C4.08253 16.5416 3.98698 17.0185 4.04273 17.4898C4.09849 17.9611 4.30266 18.4023 4.6255 18.749C4.93765 19.1063 5.35449 19.355 5.81621 19.4597C6.27792 19.5643 6.76078 19.5194 7.1955 19.3314L17.9855 14.8334C18.5747 14.5813 19.0778 14.162 19.4331 13.627C19.7883 13.0919 19.9803 12.4644 19.9855 11.8214C19.9803 11.1784 19.7883 10.5509 19.4331 10.0158C19.0778 9.48079 18.5747 9.0615 17.9855 8.80938L7.1955 4.19096C6.91072 4.07036 6.60457 4.00889 6.2955 4.01024Z"
            fill={color || '#BCBCBC'}
          />
          <path
            d="M13.5 12.7551H9.5C9.23478 12.7551 8.98043 12.6493 8.79289 12.461C8.60536 12.2727 8.5 12.0174 8.5 11.7511C8.5 11.4848 8.60536 11.2294 8.79289 11.0411C8.98043 10.8528 9.23478 10.7471 9.5 10.7471H13.5C13.7652 10.7471 14.0196 10.8528 14.2071 11.0411C14.3946 11.2294 14.5 11.4848 14.5 11.7511C14.5 12.0174 14.3946 12.2727 14.2071 12.461C14.0196 12.6493 13.7652 12.7551 13.5 12.7551Z"
            fill={color || '#BCBCBC'}
          />
        </svg>
      )}
      {variant === SendIconVariant.RENEWAL && (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
          <g transform="translate(7.2 5.5704)">
            <path
              d="M0.459723 12.8247C0.198603 12.9504 -0.0817856 12.692 0.0222357 12.4215L1.30914 6.9948C1.35666 6.87121 1.4754 6.78966 1.60781 6.78966H10.7927C11.133 6.78966 11.2381 7.25038 10.9315 7.39799L0.459723 12.8247Z"
              fill={color || '#BCBCBC'}
            />
            <path
              d="M10.9315 5.45946C11.2381 5.60707 11.133 6.06779 10.7927 6.06779H1.60781C1.4754 6.06779 1.35666 5.98623 1.30914 5.86265L0.0222358 0.435904C-0.0817855 0.165408 0.198604 -0.0929949 0.459724 0.0327201L10.9315 5.45946Z"
              fill={color || '#BCBCBC'}
            />
          </g>
        </svg>
      )}
      {variant === SendIconVariant.BUBBLE_CHAT && (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36" fill="none">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M34 18C34 9.16344 26.8366 2 18 2C9.16344 2 2 9.16344 2 18C2 26.8366 9.16344 34 18 34C26.8366 34 34 26.8366 34 18ZM12.3515 17.2485C11.8828 16.7799 11.8828 16.0201 12.3515 15.5515L17.1515 10.7515C17.6201 10.2828 18.3799 10.2828 18.8485 10.7515L23.6485 15.5515C24.1172 16.0201 24.1172 16.7799 23.6485 17.2485C23.1799 17.7172 22.4201 17.7172 21.9515 17.2485L19.2 14.4971V24.4C19.2 25.0627 18.6627 25.6 18 25.6C17.3373 25.6 16.8 25.0627 16.8 24.4V14.4971L14.0485 17.2485C13.5799 17.7172 12.8201 17.7172 12.3515 17.2485Z"
            fill={color || '#303037'}
          />
        </svg>
      )}
      {variant === SendIconVariant.OUTLINED && (
        <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M4.45914 1.75456C5.17932 1.59104 5.93278 1.65765 6.61343 1.94499L15.6046 5.69303C16.4125 6.02815 17.1028 6.59684 17.588 7.32682C18.0732 8.05679 18.331 8.91506 18.3293 9.79264C18.3321 10.6704 18.0753 11.5293 17.59 12.2594C17.1046 12.9896 16.4132 13.5581 15.6046 13.8923L6.63004 17.6237C6.19228 17.8107 5.72194 17.9103 5.24625 17.9167C4.74992 17.9169 4.25928 17.8109 3.80679 17.6061C3.35421 17.4013 2.94984 17.1018 2.62125 16.7282C2.11175 16.184 1.78733 15.4917 1.69449 14.7507C1.60166 14.0096 1.74521 13.2581 2.10464 12.6042L3.52164 9.97624C3.55429 9.91461 3.57141 9.84585 3.57144 9.77604C3.57144 9.706 3.55447 9.63667 3.52164 9.57487L2.10464 6.96452C1.74955 6.31397 1.60639 5.56825 1.69449 4.83171C1.78266 4.09504 2.09824 3.40377 2.59683 2.85612C3.08805 2.30297 3.73918 1.91804 4.45914 1.75456ZM7.91714 8.95573C7.69613 8.95573 7.48358 9.04394 7.3273 9.20085C7.17108 9.35774 7.08316 9.57079 7.08316 9.79264C7.08319 10.0145 7.17105 10.2276 7.3273 10.3844C7.48358 10.5413 7.69614 10.6296 7.91714 10.6296H11.2502C11.471 10.6296 11.6828 10.5411 11.839 10.3844C11.9953 10.2276 12.0831 10.0145 12.0832 9.79264C12.0832 9.57075 11.9953 9.35775 11.839 9.20085C11.6828 9.04408 11.4711 8.95573 11.2502 8.95573H7.91714Z"
            fill={color || theme.color.icon.icon_2}
          />
        </svg>
      )}
      {variant === SendIconVariant.FILLED && (
        <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M4.45914 1.75456C5.17932 1.59104 5.93278 1.65765 6.61343 1.94499L15.6046 5.69303C16.4125 6.02815 17.1028 6.59684 17.588 7.32682C18.0732 8.05679 18.331 8.91506 18.3293 9.79264C18.3321 10.6704 18.0753 11.5293 17.59 12.2594C17.1046 12.9896 16.4132 13.5581 15.6046 13.8923L6.63004 17.6237C6.19228 17.8107 5.72194 17.9103 5.24625 17.9167C4.74992 17.9169 4.25928 17.8109 3.80679 17.6061C3.35421 17.4013 2.94984 17.1018 2.62125 16.7282C2.11175 16.184 1.78733 15.4917 1.69449 14.7507C1.60166 14.0096 1.74521 13.2581 2.10464 12.6042L3.52164 9.97624C3.55429 9.91461 3.57141 9.84585 3.57144 9.77604C3.57144 9.706 3.55447 9.63667 3.52164 9.57487L2.10464 6.96452C1.74955 6.31397 1.60639 5.56825 1.69449 4.83171C1.78266 4.09504 2.09824 3.40377 2.59683 2.85612C3.08805 2.30297 3.73918 1.91804 4.45914 1.75456ZM7.91714 8.95573C7.69613 8.95573 7.48358 9.04394 7.3273 9.20085C7.17108 9.35774 7.08316 9.57079 7.08316 9.79264C7.08319 10.0145 7.17105 10.2276 7.3273 10.3844C7.48358 10.5413 7.69614 10.6296 7.91714 10.6296H11.2502C11.471 10.6296 11.6828 10.5411 11.839 10.3844C11.9953 10.2276 12.0831 10.0145 12.0832 9.79264C12.0832 9.57075 11.9953 9.35775 11.839 9.20085C11.6828 9.04408 11.4711 8.95573 11.2502 8.95573H7.91714Z"
            fill={color || '#F9F3F3'}
          />
        </svg>
      )}
    </i>
  );
}

export default SendIcon;
